export default "__VITE_ASSET__25c62d37__"